import React from "react";

export default function TextField({ field, value, onChange }) {
  return (
    <div className="mp-form-group">
      <label className="mp-form-label">{field._label}{field.required && " *"}</label>
      <input
        type="text"
        className="mp-form-input"
        value={value ?? ""}
        placeholder={field.placeholder || ""}
        onChange={e => onChange(field.name, e.target.value)}
      />
    </div>
  );
}
